import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class ClientService {
  #appVersion: string;
  #client: string;
  #build: string;

  public get appVersion(): string {
    return this.#appVersion ?? '0.0.0';
  }

  public get build(): string {
    return this.#build ?? '---';
  }

  public get os(): string {
    return this.#isAndroidWebView() ? 'android' : 'web';
  }

  public get client(): string {
    if (this.#client) {
      return this.#client;
    }
    return this.#isAndroidWebView() ? 'finnetapp' : 'finzero';
  }

  public set client(tenant: string) {
    this.#client = this.#getClientByTenant(tenant);
  }

  public determineAppVersion = (appVersion: string = undefined): void => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { version } = require('package.json');
    this.#appVersion = appVersion ?? version;
  };

  public setBuildVersion = (buildVersion: string = undefined): void => {
    this.#build = buildVersion ?? '---';
  };

  #isAndroidWebView = (): boolean =>
    /(Version\/\d+.*\/\d+.0.0.0 Mobile|; ?wv|(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari))/i.test(navigator?.userAgent);

  #getClientByTenant = (tenant: string): string => {
    switch (tenant) {
      case 'finanzen.net':
        return 'finnet';
      case 'finanzen.at':
        return 'finnat';
      default:
        throw new Error(`No client defined for tenant: ${tenant}`);
    }
  };
}
